<template>
  <div id="user-top-desktop" class="info-box border-radius-bottom hidden-xs hidden-sm">
    <div class="px-15 flex">
      <div class="login-logo">
        <img v-if="!$auth.check()" src="https://static.phdvasia.com/my/icons/inactive@2x.png" class="opacity-5" width="22">
        <img src="https://static.phdvasia.com/my/icons/active@2x.png" width="23" v-else>
      </div>
      <div class="login-box">
        <span v-if="$auth.check() ">
          <router-link v-if="$i18n.locale == $const.LANG_JP" to="/profile">{{$t('full_name_format', {say_hi: 'Hello,',last_name:$auth.user().last_name})}}</router-link>
          <router-link v-else to="/profile">{{$t('full_name_format', {first_name:$auth.user().first_name, last_name:$auth.user().last_name})}}</router-link>
        </span>
        <router-link v-else :to="{name: 'login'}">
          {{ $t("login_title") }}
        </router-link>
        <span>
          <router-link to="/signup" v-if="!$auth.check()">/ {{ $t("login_register")}}</router-link>
          <button v-else v-on:click="$root.$emit('logout')">/ {{ $t("button_logout")}}</button>
        </span>
      </div>
    </div>
    <div v-if="!voucher" class="hut-rewards--flat-button">
      <router-link :to="{name: 'hut-rewards'}">
        <span class="hut-rewards-logo"></span>
      </router-link>
    </div>
    <!-- <div  class="hut-rewards--flat-button"  v-if="$auth.check() && !voucher">
      <div class="login-box">
        <div class="flag-inner">
          <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY">
            <span>{{(cart.customer_point != undefined ? cart.customer_point : ($auth.user().point ? $auth.user().point : 0))}} {{ $t("slices")}}
              <img style="max-width: 20px;" src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png">
            </span>
          </router-link>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  mounted () {
    this.$cart.init(this)
  },
  props: ['voucher'],
  data() {
    return {}
  },
  methods: {}
}

</script>



// WEBPACK FOOTER //
// src/components/partials/UserTopDesktop.vue